import { HttpHeaders } from '@angular/common/http';
import { HttpService } from '../http.service';
import { Injectable, Injector } from '@angular/core';
import { SaveClientRequest } from './data.model';
import { ApiHelper } from './api-helper';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ClientRequest {
  constructor(private api: HttpService) {}

  sendReq(data: SaveClientRequest) {
    return this.api.post(ApiHelper.saveClientRequest, data);
  }

  getReq(faq) {
    return this.api.getFaq(faq);
  }

  getNews(newslistcount) {
    return this.api.getNews(newslistcount);
  }

  getNewsDetail(newsId) {
    return this.api.getNewsDetail(newsId);
  }

  getCity(data){
    return this.api.getDict(data);
  }
  getDist(data){
    return this.api.getDist(data);
  }
  getSubDist(data){
    return this.api.getSubDist(data);
  }
  getBannerList(data){
    return this.api.getBannerList(data);
  }
}
